import React, { useContext, useEffect, useRef, useState } from "react";
import parse from "html-react-parser";
import {
  Box,
  Grid,
  Typography,
  Divider,
  Link,
  IconButton,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import WorkIcon from "@mui/icons-material/Work";
import HomeIcon from "@mui/icons-material/Home";
import EditIcon from "@mui/icons-material/Edit";
import AirplanemodeActiveIcon from "@mui/icons-material/AirplanemodeActive";
import { resumeBuilderSelector } from "../ResumeBuilderActions/selector";
import ResumeContext from "../Resumecontext";
import { setCurrentSection } from "../ResumeBuilderActions/actions";

export default function Template1({
  selectedSummaries,
  addedSkills,
  responsibilities,
  forPDF = false,
  accentColor = "#2563EB"
}) {
  const dispatch = useDispatch();
  const contextObject = useContext(ResumeContext);
  const { currentSection, resumeProjectsData, projects, resumeFullDetails } =
    useSelector(resumeBuilderSelector);
  //console.log(currentSection);

  //console.log("resumeProjectsDatatemp", resumeProjectsData);

  const {
    resumedetails = [],
    projectdetails = [],
    educationdetails = [],
    certificatedetails = [],
    skillsdetails = [],
  } = resumeFullDetails || {};


  const [displayedProjects, setDisplayedProjects] = useState([]);

  useEffect(() => {
    if (currentSection?.section === "Project") {
      //console.log("Displaying projects:", projects);
      setDisplayedProjects(projects);
    } else {
      // alert("else")
      //console.log("Displaying project details:", projectdetails);
      setDisplayedProjects(projectdetails);
    }
  }, [currentSection, projects, projectdetails]);
  //projectdetails,

  const handleEditClick = (section, id) => {
    dispatch(setCurrentSection(section, id));
  };

  const highlightsummary = (text, selectedWords, forPDF = false) => {
    if (!text) return "";
    let formatTagCounter = 0;
    const formatTagMap = new Map();

    const preserveFormatting = text
      .replace(/<(\/?)(?:b|strong|i|em|u|strike|sub|sup|mark)(\s[^>]*)?>/gi,
        (match) => {
          const token = `[FORMAT-TAG-${formatTagCounter++}]`;
          formatTagMap.set(token, match);
          return token;
        })
      .replace(/<(?!\/?(?:b|strong|i|em|u|strike|sub|sup|mark)(\s[^>]*)?\/?>)[^>]+>/g, "")
      .trim();

    const protectedText = preserveFormatting
      .replace(/\.(net|js|ts|py|rb|php|java|cpp|cs|go|rs|swift|kt)/gi,
        match => match.replace(/\./g, "[TECHDOT]"))
      .replace(/(\d+)\.(\d+)(\.\d+)?/g,
        match => match.replace(/\./g, "[VERDOT]"))
      .replace(/\b(e\.g\.|i\.e\.|Dr\.|Mr\.|Ms\.|Mrs\.|vs\.|etc\.)/gi,
        match => match.replace(/\./g, "[ABBRDOT]"));
    let sentences = [];
    if (text.includes('<li>') || text.includes('<ul>')) {
      const liRegex = /<li>(.*?)<\/li>/g;
      let match;
      while ((match = liRegex.exec(text)) !== null) {
        if (match[1] && match[1].trim()) {
          sentences.push(match[1].trim());
        }
      }
    }
    else if (protectedText.includes('\n') || protectedText.includes('<br') || protectedText.includes('•') || protectedText.includes('•')) {
      sentences = protectedText
        .split(/\n|<br\s*\/?>|•/)
        .map(s => s.trim())
        .filter(s => s.length > 0);
    }
    else {
      const sentenceRegex = /[^.!?]+[.!?]+(?=\s*[A-Z]|$)/g;
      sentences = protectedText.match(sentenceRegex);

      if (!sentences) {
        sentences = [protectedText];
      }
    }

    sentences = sentences.map(sentence =>
      sentence
        .replace(/\[TECHDOT\]/g, ".")
        .replace(/\[VERDOT\]/g, ".")
        .replace(/\[ABBRDOT\]/g, ".")
        .replace(/^[,\s•\-]+/, "") // Strip leading commas and whitespace
        .trim()
    ).filter(s => s.length > 0);

    // Step 4: Prepare selected words for highlighting
    const escapedWords = selectedWords?.filter(Boolean).map((word) =>
      word.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&")
    );
    const regex = escapedWords?.length && escapedWords.some(word => word.trim() !== "")
      ? new RegExp(`(${escapedWords.join("|")})`, "gi")
      : null;

    const bulletPoints = sentences.map(sentence => {
      let highlighted = sentence;
      if (!forPDF && regex) {
        highlighted = sentence.replace(regex, `<span class="highlighted-text" style="background-color: yellow;">$1</span>`);
      }

      let formattedSentence = highlighted;
      formatTagMap.forEach((value, key) => {
        formattedSentence = formattedSentence.replace(new RegExp(key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), value);
      });

      return `<li style="margin-bottom: 2px;">${formattedSentence}</li>`;
    });

    return `<ul style="padding-left: 25px; margin: 0; text-align: left; width: 100%; list-style-position: outside;">${bulletPoints.join("")}</ul>`;
  };


  const highlightResponsibility = (text, selectedWords, forPDF = false) => {
    if (!text) return parse("");

    let formatTagCounter = 0;
    const formatTagMap = new Map();

    const preserveFormatting = text
      .replace(/<(\/?)(?:b|strong|i|em|u|strike|sub|sup|mark)(\s[^>]*)?>/gi,
        (match) => {
          const token = `[FORMAT-TAG-${formatTagCounter++}]`;
          formatTagMap.set(token, match);
          return token;
        })
      .replace(/<(?!\/?(?:b|strong|i|em|u|strike|sub|sup|mark)(\s[^>]*)?\/?>)[^>]+>/g, "")
      .trim();
    const protectedText = preserveFormatting
      .replace(/\.(net|js|ts|py|rb|php|java|cpp|cs|go|rs|swift|kt)/gi,
        match => match.replace(/\./g, "[TECHDOT]"))
      .replace(/(\d+)\.(\d+)(\.\d+)?/g,
        match => match.replace(/\./g, "[VERDOT]"))
      .replace(/\b(e\.g\.|i\.e\.|Dr\.|Mr\.|Ms\.|Mrs\.|vs\.|etc\.)/gi,
        match => match.replace(/\./g, "[ABBRDOT]"));
    let sentences = [];
    if (text.includes('<li>') || text.includes('<ul>')) {
      const liRegex = /<li>(.*?)<\/li>/g;
      let match;
      while ((match = liRegex.exec(text)) !== null) {
        if (match[1] && match[1].trim()) {
          sentences.push(match[1].trim());
        }
      }
    }
    else if (protectedText.includes('\n') || protectedText.includes('<br') || protectedText.includes('•')) {
      sentences = protectedText
        .split(/\n|<br\s*\/?>|•/)
        .map(s => s.trim())
        .filter(s => s.length > 0);
    }
    else {
      const sentenceRegex = /[^.!?]+[.!?]+/g;
      const matches = protectedText.match(sentenceRegex);
      if (matches && matches.length > 0) {
        sentences = matches;
      } else {
        sentences = [protectedText];
      }
    }
    sentences = sentences
      .map(s => s
        .replace(/\[TECHDOT\]/g, ".")
        .replace(/\[VERDOT\]/g, ".")
        .replace(/\[ABBRDOT\]/g, ".")
        .replace(/^[,\s•\-]+/, "") // Strip leading commas and whitespace
        .trim()
      )
      .filter(s => s.length > 0);

    //console.log("Processed sentences:", sentences);
    const escapedWords = selectedWords?.filter(Boolean).map(word =>
      word.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&")
    );
    const regex = escapedWords?.length && escapedWords.some(word => word.trim() !== "")
      ? new RegExp(`(${escapedWords.join("|")})`, "gi")
      : null;

    const bulletPoints = sentences.map(sentence => {
      let highlighted = sentence;
      if (!forPDF && regex) {
        highlighted = sentence.replace(regex, `<span style="background-color: yellow;">$1</span>`);
      }

      let formattedSentence = highlighted;
      formatTagMap.forEach((value, key) => {
        formattedSentence = formattedSentence.replace(new RegExp(key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), value);
      });

      return `<li style="margin-bottom: 2px;">${formattedSentence}</li>`;
    });

    return parse(`<ul style="margin: 0; padding-left: 25px; width: 100%; list-style-position: outside;">${bulletPoints.join("")}</ul>`);
  };
  return (
    <Grid item xs={12}>
      <Box
        sx={{
          mx: 2,
          mt: 1,
          //mb: 2,
          textAlign: "center",
          fontWeight: "bold",
          // color: getTextColor(bgColor),
          //background: gradient,
          pb: 1,
          position: "relative",
          "&:hover .editIcon": {
            visibility: "visible",
          },
        }}
      >
        <Typography
          variant="body1"
          sx={{
            fontSize: "16px",
            fontWeight: "bold",
            fontFamily: "'Times New Roman', serif !important",
          }}
        >
          {" "}
          {resumedetails?.full_name}{" "}
        </Typography>
        <Typography
          sx={{
            fontSize: "14px",
            fontFamily: "'Times New Roman', serif !important",
          }}
        >
          {" "}
          {contextObject.jobTitle
            ? contextObject.jobTitle
            : resumedetails.application_title}
          {/* { resumedetails.application_title} */}
        </Typography>
        <Typography sx={{ fontSize: "12px" }}>
          {`${resumedetails?.email} ${resumedetails?.home_phone && ` | ${resumedetails.home_phone}`
            }`}
        </Typography>
        <Typography
          sx={{
            fontSize: "12px",
          }}
        >
          <Link
            href={resumedetails?.linkedin_url}
            target="_blank"
            rel="noopener"
            sx={{
              mr: 1,
              // color: getTextColor(bgColor),
              textDecoration: "none",
            }}
          >
            {resumedetails?.linkedin_url}
          </Link>
        </Typography>
        {/* <Divider /> */}
      </Box>
      <Box
        sx={{
          mx: 2,
          fontWeight: "bold",
        }}
      >
        <Typography
          variant="body1"
          sx={{
            //color: gradientEnd,
            fontWeight: "bold",
            fontSize: "15px",
            fontFamily: "'Times New Roman', serif !important",
          }}
        >
          Professional Summary :
        </Typography>
        <Divider />
        <Typography
          sx={{
            mt: 1,
            fontSize: "12px",
            textAlign: forPDF ? "left" : "justify",
            fontFamily: "'Times New Roman', serif !important",
            width: "100%",
            "& .highlighted-text": {
              backgroundColor: "yellow",
            },
          }}
        >
          {parse(
            highlightsummary(
              contextObject.summary ||
              (resumedetails.summary && resumedetails.summary !== "null"
                ? resumedetails.summary
                : ""),
              selectedSummaries,
              forPDF
            )
          )}
        </Typography>
      </Box>
      <Box
        sx={{
          width: "100%",
          "&:hover .editIcon": {
            visibility: "visible",
          },
        }}
      >
        <Typography
          variant="body1"
          sx={{
            mx: 2,
            my: 0.5,
            // color: gradientEnd,
            fontWeight: "bold",
            fontFamily: "'Times New Roman', serif !important",
            //width: "110px",
            fontSize: "15px",
            //px: 1,
          }}
        >
          Technical Skills :
        </Typography>
        <Divider
          sx={{
            mx: 2,
          }}
        />
        <Box
          sx={{
            borderRadius: "25px 0px",
            py: 1,
          }}
        >
          <Box sx={{ mx: 2 }}>
            <Typography
              sx={{
                fontSize: "12px",
                color: "black",
                textTransform: "capitalize",
              }}
            >
              {(() => {
                const skills = [
                  ...new Set(
                    [resumedetails?.ai_skills, contextObject?.aiSkills]
                      .filter(Boolean)
                      .join(", ")
                      .split(",")
                      .map((skill) => skill.trim())
                      .filter(Boolean)
                  ),
                ];

                return skills.map((skill, index, array) => (
                  <span
                    key={index}
                    style={{
                      fontWeight: addedSkills?.includes(skill)
                        ? "normal"
                        : "normal",
                      backgroundColor: (addedSkills?.includes(skill) && !forPDF)
                        ? "yellow"
                        : "transparent",
                    }}
                  >{skill}{index !== array.length - 1 ? ", " : ""}</span>
                ));
              })()}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Typography
        variant="body1"
        sx={{
          mx: 2,
          fontWeight: "bold",
          fontSize: "15px",
          fontFamily: "'Times New Roman', serif !important",
        }}
      >
        Professional Experience :{" "}
      </Typography>
      <Divider
        sx={{
          mx: 2,
        }}
      />
      <Box sx={{ mx: 2, fontWeight: "normal" }}>
        {displayedProjects?.length > 0 ? (
          <div>
            <Box>
              {displayedProjects.map((item, index) => (
                <Box
                  sx={{
                    width: "100%",
                    fontSize: "12px",
                    position: "relative",
                    "&:hover .editIcon": {
                      visibility: "visible",
                    },
                  }}
                >
                  <Box
                    sx={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Box>
                      <Typography
                        sx={{
                          fontSize: "15px",
                          fontWeight: "bold",
                          color: "black",
                          fontFamily: "'Times New Roman', serif !important",
                        }}
                      >
                        {item.pro_title}
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "13px",
                            fontFamily: "'Times New Roman', serif !important",
                            color: "black",
                            fontWeight: 600,
                          }}
                        >
                          {item.pro_client}
                        </Typography>
                        {item.pro_role && (
                          <Typography
                            sx={{
                              fontSize: "14px",
                              mx: 1,
                            }}
                          >
                            |
                          </Typography>
                        )}

                        <Typography
                          sx={{
                            fontSize: "13px",
                            color: "black",
                            fontFamily: "'Times New Roman', serif !important",
                            fontWeight: 600,
                          }}
                        >
                          {item.pro_role}
                        </Typography>
                      </Box>
                    </Box>
                    <Box sx={{ mx: 2 }}>
                      <Typography sx={{ fontSize: "12px" }}>
                        {item.pro_startdate
                          ? moment(item.pro_startdate).format("MMM YYYY")
                          : "Not available"}{" "}
                        -{" "}
                        {item.is_current_project === 1
                          ? "Present"
                          : item.pro_enddate
                            ? moment(item.pro_enddate).format("MMM YYYY")
                            : "Till date"}
                        {currentSection?.section === "Project" && (
                          <IconButton
                            className="editIcon"
                            size="small"
                            sx={{
                              ml: 1,
                              visibility: "hidden",
                              p: 0,
                              color: accentColor
                            }}
                            onClick={() => handleEditClick("Project", item.id)}
                          >
                            <EditIcon sx={{ fontSize: "14px" }} />
                          </IconButton>
                        )}
                      </Typography>
                      <Typography sx={{ fontSize: "12px" }}>
                        {/* {item.cityname !== undefined && item.cityname !== null
                          ? item.cityname + " , " + item.shortRegion
                          : item.pro_city
                          ? item.pro_city + " , " + item.pro_state
                          : ""} */}
                        {/* {item.pro_address_full &&
                          item.pro_address_full !== undefined &&
                          item.pro_address_full !== "0,0" &&
                          item.pro_address_full !== "0, 0" &&
                          item.pro_address_full} */}
                      </Typography>
                    </Box>
                  </Box>
                  <Box sx={{ width: "100%", mt: 0.5, mb: 2 }}>
                    <Typography
                      sx={{
                        fontSize: "12px",
                        fontWeight: "bold",
                        color: "black",
                        fontFamily: "'Times New Roman', serif !important",
                      }}
                    >
                      {item.pro_description &&
                        item.pro_description !== "null" &&
                        item.pro_description !== "undefined" ? (
                        <>Description: </>
                      ) : (
                        ""
                      )}
                    </Typography>
                    <Box component="div" sx={{
                      fontSize: "12px",
                      fontFamily: "'Times New Roman', serif !important",
                      width: "100%",
                      lineHeight: 1.5,
                      "& p": { margin: 0, fontSize: "12px" },
                    }}>
                      {item.pro_description &&
                        item.pro_description !== null &&
                        item.pro_description !== "null" &&
                        item.pro_description !== "undefined" &&
                        item.pro_description !== undefined
                        ? <span style={{ fontSize: "12px", fontFamily: "'Times New Roman', serif" }}>
                          {parse(item.pro_description)}
                        </span>
                        : ""}
                    </Box>
                    <Typography
                      sx={{
                        fontSize: "12px",
                        fontWeight: "bold",
                        color: "black",
                        fontFamily: "'Times New Roman', serif !important",
                      }}
                    >
                      {item.pro_responsibilities &&
                        item.pro_responsibilities !== "null" &&
                        item.pro_responsibilities !== "undefined" ? (
                        <> Roles & Responsibilities : </>
                      ) : (
                        ""
                      )}
                    </Typography>
                    <Box component="div" sx={{ fontSize: "12px", textAlign: forPDF ? "left" : "justify", fontFamily: "'Times New Roman', serif !important", width: "100%" }}>
                      {(() => {
                        const raw = item.pro_responsibilities;
                        if (!raw || raw === "null" || raw === "undefined") return " ";

                        let normalizedResponsibilities;
                        if (Array.isArray(raw)) {
                          normalizedResponsibilities = `<ul style="padding-left: 25px; margin: 0;">${raw
                            .filter(r => r && r.trim())
                            .map(r => `<li>${r.trim()}</li>`)
                            .join("")}</ul>`;
                        } else {
                          normalizedResponsibilities = raw.trim();
                        }

                        return highlightResponsibility(normalizedResponsibilities, responsibilities, forPDF);
                      })()}
                    </Box>
                  </Box>
                </Box>
              ))}
            </Box>
          </div>
        ) : (
          ""
        )}
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Box>
            <Typography
              variant="body1"
              sx={{
                mx: 2,
                my: 0.5,
                // color: gradientEnd,
                fontWeight: "bold",
                fontSize: "15px",
                fontFamily: "'Times New Roman', serif !important",
              }}
            >
              {educationdetails?.filter(item =>
                item.edu_course &&
                item.edu_course !== "null" &&
                item.edu_course !== "undefined" &&
                item.edu_course.trim() !== ""
              ).length > 0 && "Education :"}
            </Typography>
            <Divider
              sx={{
                mx: 2,
                // border: `1px solid  ${bgColor}`,
              }}
            />
            <Box sx={{ mx: 2, fontWeight: "bold" }}>
              {educationdetails?.filter(item =>
                (item.edu_course && item.edu_course !== "null" && item.edu_course !== "undefined" && item.edu_course.trim() !== "") ||
                (item.edu_university && item.edu_university !== "null" && item.edu_university !== "undefined" && item.edu_university.trim() !== "")
              ).length > 0 ? (
                <div>
                  {educationdetails
                    .filter(item =>
                      (item.edu_course && item.edu_course !== "null" && item.edu_course !== "undefined" && item.edu_course.trim() !== "") ||
                      (item.edu_university && item.edu_university !== "null" && item.edu_university !== "undefined" && item.edu_university.trim() !== "")
                    )
                    .map((item, index) => (
                      <Box
                        key={item.id || index}
                        sx={{
                          width: "100%",
                          // mx: 2,
                          fontSize: "12px",
                        }}
                      >
                        <Box
                          sx={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Box>
                            <Typography
                              sx={{
                                fontWeight: "bold",
                                fontSize: "14px",
                                fontFamily:
                                  "'Times New Roman', serif !important",
                              }}
                            >
                              {item.edu_university && item.edu_university !== "null" && item.edu_university !== "undefined" ? item.edu_university : ""}
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: "12px",
                                fontFamily: "sans-serif",
                                fontStyle: "italic",
                              }}
                            >
                              {item.edu_course && item.edu_course !== "null" && item.edu_course !== "undefined" ? item.edu_course : ""}
                            </Typography>
                          </Box>
                          <Box sx={{ mx: 2 }}>
                            <Typography sx={{ fontSize: "12px" }}>
                              {item.edu_passing_year && item.edu_passing_year !== "null" && item.edu_passing_year !== "undefined" ? item.edu_passing_year : ""}
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    ))}
                </div>
              ) : (
                ""
              )}
            </Box>
          </Box>
        </Grid>
        <Grid item xs={6}>
          <Box>
            <Typography
              variant="body1"
              sx={{
                mx: 2,
                my: 0.5,
                // color: gradientEnd,
                fontWeight: "bold",
                fontSize: "18px",
                fontFamily: "'Times New Roman', serif !important",
              }}
            >
              {certificatedetails?.length > 0 &&
                certificatedetails[0]?.cer_name &&
                certificatedetails[0]?.cer_name !== "undefined" &&
                certificatedetails[0]?.cer_name !== undefined &&
                certificatedetails[0]?.cer_name.trim() !== "" &&
                "Certification :"}
            </Typography>

            {certificatedetails?.length > 0 &&
              certificatedetails[0]?.cer_name &&
              certificatedetails[0]?.cer_name !== "undefined" &&
              certificatedetails[0]?.cer_name !== undefined &&
              certificatedetails[0]?.cer_name.trim() !== "" && (
                <Divider
                  sx={{
                    mx: 2,
                  }}
                />
              )}

            <Box sx={{ mx: 2, fontWeight: "bold" }}>
              {certificatedetails?.filter(item =>
                item.cer_name &&
                item.cer_name !== "null" &&
                item.cer_name !== "undefined" &&
                item.cer_name.trim() !== ""
              ).length > 0 ? (
                <div>
                  {certificatedetails
                    .filter(item =>
                      item.cer_name &&
                      item.cer_name !== "null" &&
                      item.cer_name !== "undefined" &&
                      item.cer_name.trim() !== ""
                    )
                    .map((item, index) => (
                      <Box
                        key={index}
                        sx={{
                          width: "100%",
                          // mx: 2,
                          fontSize: "12px",
                        }}
                      >
                        <Box
                          sx={{
                            width: "100%",

                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Box>
                            <Typography
                              sx={{
                                fontWeight: "bold",
                                fontSize: "14px",
                                fontFamily: "'Times New Roman', serif !important",
                              }}
                            >
                              {item.cer_name}
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: "12px",
                                fontFamily: "sans-serif",
                                //fontStyle: 'italic',
                              }}
                            >
                              {item.certificatelink && item.certificatelink !== "null" && item.certificatelink !== "undefined" ? item.certificatelink : ""}
                            </Typography>
                          </Box>
                          <Box sx={{ mx: 2 }}>
                            <Typography sx={{ fontSize: "12px" }}>
                              {item.cer_year && item.cer_year !== "null" && item.cer_year !== "undefined" ? item.cer_year : ""}{" "}
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    ))}
                </div>
              ) : (
                ""
              )}
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Box
        sx={{
          width: "100%",
          mt: 0.5,
          mx: -1,
          // borderBottom: `3px solid ${gradiantMiddile}`,
          // borderTop: `3px solid ${gradiantMiddile}`,
          // borderLeft: `1px solid ${gradiantMiddile}`,
          // borderRight: `1px solid ${gradiantMiddile}`,
          borderRadius: "25px",
          px: 2,
        }}
      >
        {resumedetails.statename && (
          <Typography
            sx={{
              fontSize: "13px",
              fontFamily: "'Georgia', serif !important",
              color: "black",
              fontWeight: "bold",
            }}
          >
            {" "}
            <HomeIcon
              style={{
                //fill: gradiantMiddile,
                fontSize: "13px",
              }}
            />{" "}
            {resumedetails.cityname},{resumedetails.statename}
          </Typography>
        )}
        {resumedetails.visatype && (
          <Typography
            sx={{
              fontSize: "13px",
              fontFamily: "'Georgia', serif !important",
              color: "black",
            }}
          >
            {" "}
            <AirplanemodeActiveIcon
              style={{
                //fill: gradiantMiddile,
                fontSize: "13px",
              }}
            />{" "}
            {resumedetails.visatype_name !== null
              ? resumedetails.visatype_name
              : resumedetails.visatype}
          </Typography>
        )}
        {resumedetails.jobtypeNames && (
          <Typography
            sx={{
              fontSize: "12px",
              fontFamily: "'Georgia', serif !important",
              color: "black",
            }}
          >
            {" "}
            <WorkIcon
              style={{
                //fill: gradiantMiddile,
                fontSize: "13px",
              }}
            />{" "}
            {resumedetails.jobtypeNames}
          </Typography>
        )}
      </Box>
    </Grid>
  );
}
